<!-- Content -->
<div class="flex flex-column row-gap-2 justify-content-center align-items-center w-full h-full mb-2">
  <div class="field w-full">
    <label
      id="image_title_label"
      class="flex flex-grow-1"
      for="image_title">
      <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
        {{ label | translate }}
      </span>
    </label>
    <div medsurf-design-content-input-group>
      <medsurf-design-input-text [name]="'image_title'"
                                  [formField]="false"
                                  [class]="'w-full'"
                                  [disabled]="true"
                                  [model]="media?.name || 'global.no_image' | translate">
      </medsurf-design-input-text>
      <medsurf-design-input-menu [name]="'image_menu'"
                                  [tooltipLabel]="'global.image_menu' | translate"
                                  [buttonInputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY"
                                  [iconOpen]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.OPTIONS"
                                  [iconClose]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.OPTIONS"
                                  [loadMenuItems]="getImageMenuItems"></medsurf-design-input-menu>
    </div>
  </div>
  <div class="relative mb-2">
    @if (media?.access === 'private') {
      <p-tag 
        [value]="'enum.media.private' | translate" 
        class="absolute bottom-0 left-0 m-2" 
        severity="danger" />
    }
    <img class="max-w-full block w-auto max-h-20rem"
         [src]="media ? mediaControlService.getUrl(media, 'thumbnail') || '/assets/images/no-image.png' : '/assets/images/no-image.png'"
         [alt]="media?.name || 'global.error_loading_image' | translate" />
  </div>
</div>
